/**
 * Thin wrapper around `sessionStorage` that never throws.
 *
 * Storage access can fail (private mode, exceeded quota, storage disabled by
 * browser policy). Callers get a safe fallback instead of an exception, so a
 * persistence failure never breaks the calling flow.
 */
export const safeSessionStorage = {
  get(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // Storage full or unavailable — skip silently.
    }
  },
  remove(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // Storage unavailable — ignore.
    }
  },
};
